import apiInstance from '@/axios';

// 이미지 저장 기본 경로
const BASE_PATH = 'certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife';

/**
 * 병원타입/시술구분별 제조사 목록 조회 (이미지 정보 포함)
 * @param {string} hospitalType - 병원 타입 코드 (DENT, OPH, PS, DERM, OS, VET_COMMON)
 * @param {string} surgeryType - 시술 구분 코드 (IMPLANT, ABUTMENT, ZIRCONIA 등)
 * @returns {Promise<Object>} 제조사 목록 (imgUrl, imgUrl2, iconUrl 포함)
 */
export const getManufacturersBySurgery = async (hospitalType, surgeryType) => {
  const response = await apiInstance.get(`/accounts/issue/manufacturers/${hospitalType}/${surgeryType}`);
  return response.data;
};

/**
 * 제조사 정보 업데이트 (이미지 포함)
 * PUT /accounts/medical-manufacturers/:manufacturerId
 *
 * @param {string} manufacturerId - 제조사 ID
 * @param {Object} data - 업데이트할 데이터 (모든 필드 Optional)
 *   - isCertified, name, iconUrl, imgUrl, imgUrl2
 *   - colorCode, nftTitle, nftTitle2
 *   - klipCompanyName, objectIdKey
 *   - description, description2
 *   - displayOrder, translatedText
 * @returns {Promise<Object>} 업데이트 결과
 */
export const updateManufacturerImage = async (manufacturerId, data) => {
  const response = await apiInstance.put(`/accounts/medical-manufacturers/${manufacturerId}`, data);
  return response.data;
};

/**
 * 이미지 업로드 폴더 경로 생성
 * @param {string} imageType - 이미지 타입 ('iconUrl', 'imgUrl', 'imgUrl2')
 * @param {string} hospitalType - 진료과목 코드 (DENT, OPH, PS 등)
 * @returns {string} 폴더 경로
 */
export const getUploadFolderPath = (imageType, hospitalType) => {
  if (imageType === 'iconUrl') {
    // 아이콘은 nft_round 폴더에 저장
    return `${BASE_PATH}/nft_round/`;
  } else {
    // 메인/서브 이미지는 nft_card/{진료과목}/ 폴더에 저장
    return `${BASE_PATH}/nft_card/${hospitalType}/`;
  }
};

/**
 * Azure Storage에 이미지 파일 업로드
 * @param {File} file - 업로드할 파일
 * @param {string} imageType - 이미지 타입 ('iconUrl', 'imgUrl', 'imgUrl2')
 * @param {string} hospitalType - 진료과목 코드 (DENT, OPH, PS 등)
 * @returns {Promise<Object>} 업로드 결과 (URL 포함)
 */
export const uploadCertificateImage = async (file, imageType, hospitalType) => {
  const formData = new FormData();
  formData.append('files', file);

  // 폴더 경로 생성
  const folderPath = getUploadFolderPath(imageType, hospitalType);

  // URL 생성 - folderPath를 URL 인코딩
  const url = `/object-storages/azure/files/upload?folderPath=${encodeURIComponent(folderPath)}`;

  console.log('인증서 이미지 업로드 요청:', {
    url,
    folderPath,
    fileName: file.name,
    fileSize: file.size,
    imageType,
    hospitalType,
  });

  const response = await apiInstance.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    timeout: 60000, // 60초 타임아웃
  });

  console.log('인증서 이미지 업로드 응답:', response.data);

  return response.data;
};

/**
 * 이미지 파일 업로드 (기본 - 레거시 호환)
 * @param {FormData} formData - 이미지 파일
 * @returns {Promise<Object>} 업로드 결과 (URL 포함)
 */
export const uploadImage = async (formData) => {
  const response = await apiInstance.post('/files/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};
